/**
 * @generated SignedSource<<078b4ea4c0e25d28b9a9b92336ca4035>>
 * @relayHash 98222d64d2cb70561d6085bba464f428
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98222d64d2cb70561d6085bba464f428

import { ConcreteRequest } from 'relay-runtime';
export type medicalRecordLinkIdentifiersQuery$variables = {
  appointmentNodeId: string;
  hasAppointmentNodeId: boolean;
  patientNodeId: string;
};
export type medicalRecordLinkIdentifiersQuery$data = {
  readonly appointment?: {
    readonly internalId: string;
    readonly internalIdRuntimeType: string;
    readonly typeName: string;
  } | null;
  readonly patient: {
    readonly internalId: string;
    readonly internalIdRuntimeType: string;
    readonly typeName: string;
  } | null;
};
export type medicalRecordLinkIdentifiersQuery = {
  response: medicalRecordLinkIdentifiersQuery$data;
  variables: medicalRecordLinkIdentifiersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appointmentNodeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasAppointmentNodeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientNodeId"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "typeName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalIdRuntimeType",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": "patient",
    "args": [
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "patientNodeId"
      }
    ],
    "concreteType": "ParsedNodeIdOutput",
    "kind": "LinkedField",
    "name": "parseNodeId",
    "plural": false,
    "selections": (v3/*:: as any*/),
    "storageKey": null
  },
  {
    "condition": "hasAppointmentNodeId",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "appointment",
        "args": [
          {
            "kind": "Variable",
            "name": "nodeId",
            "variableName": "appointmentNodeId"
          }
        ],
        "concreteType": "ParsedNodeIdOutput",
        "kind": "LinkedField",
        "name": "parseNodeId",
        "plural": false,
        "selections": (v3/*:: as any*/),
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "medicalRecordLinkIdentifiersQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "medicalRecordLinkIdentifiersQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "id": "98222d64d2cb70561d6085bba464f428",
    "metadata": {},
    "name": "medicalRecordLinkIdentifiersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f688d16cd79f84b25ae5fb34655a60dd";

export default node;
